<template>
	<button
		type="button"
		:class="classes"
		v-bind="$attrs"
		:disabled="disabled"
		@click="onClick"
	>
		<span class="button__wrap">
			<p-loading
				v-if="loading"
				:diameter="loadingDiameter"
			/>
			<slot />
		</span>
	</button>
</template>

<script lang="ts" setup>
import {computed} from 'vue';
import PLoading from '../pLoading/pLoading.vue';

interface Props {
	type?: string,
	block?: boolean,
	loading?: boolean,
	size?: 'small' | 'medium' | 'large',
	disabled?: boolean,
	loadingDiameter?: number,
}

// Props
const props = withDefaults( defineProps<Props>(), { size: 'large', loadingDiameter: 16 });

// Emits
const emit = defineEmits<{
	(e: 'click', id: number): void;
}>();

// Computed
const classes = computed(() => ({
	'p-button_default': true,
	'p-button_border': props.type === 'border',
	'p-button_small': props.size === 'small',
	'p-button_medium': props.size === 'medium',
	'p-button_large': props.size === 'large',
	'p-button_disabled': props.disabled || props.loading,
	'p-button_block': props.block,
	'p-button_loading': props.loading,
}));

// Methods
const onClick = () => {
	emit('click', 1);
};

</script>
<style lang="scss" src="./styles/pButton.scss"></style>